let themes = require('../../../../common/data/themes');

const angular = require('angular')

angular.module('clientDashboardApp').factory('defaultEmailAlertTemplates', function (emailAlertData) {
  return emailAlertData.then(emailAlertConfig => {
    const gadgets = () => emailAlertConfig.data.GADGETS
    const realtimeGadgets = () => emailAlertConfig.realtimeData.GADGETS

    return {
      data: () => {
        return [
          {
            id: "RealTimeReviews",
            name: "Real-Time Reviews",
            description: `An email is sent whenever you receive a new review. <em>Note: Providers currently supported: Google, Facebook, Review Builder, Yelp.</em>`,
            templateType: "emailAlert",
            previewImg: "/images/emailAlerts/templates/images/daily-alert.jpg",
            subject: "You've received a review",
            trigger: {
              eventName: "NEW_REVIEW",
              delayMins: 0
            },
            gadgets: realtimeGadgets()
          },
          {
            id: "DailyReviews",
            name: "Daily Reviews Template",
            description: `
      A daily e-mail alert with the details you need in order to manage your online reviews. Read what customers are saying about you, monitor responses from your team members, and follow up on customer issues as needed.
    `,
            templateType: "emailAlert",
            previewImg: "/images/emailAlerts/templates/images/daily-alert.jpg",
            schedule: {
              scheduleType: "Daily",
              deliveryHour: 0,
              deliveryTimeZone: "US/Pacific"
            }, gadgets: gadgets().filter(gadget => (["reviewRecap","reviewDetails"/*, "social", "media"*/].indexOf(gadget.type) >= 0 )),
            subject: "Your Daily Summary"
          },
          {
            id: "WeeklySocial",
            name: "Weekly Social Template",
            description: `
      A weekly report tracking your growth on social media, including followers and post counts.  Also includes an analysis of trending hashtags about your business and provides some recent examples.
    `,
            templateType: "emailAlert",
            previewImg: "/images/emailAlerts/templates/images/weekly-social.jpg",
            schedule: {
              scheduleType: "Weekly",
              scheduleDay: [1],
              deliveryHour: 0,
              deliveryTimeZone: "US/Pacific"
            }, gadgets: gadgets().filter(gadget => (["social"].indexOf(gadget.type) >= 0 )),
            subject: "Your Weekly Social Summary"
          },
          {
            id: "MonthlyReport",
            name: "Monthly Report Template",
            description: `
      A monthly report containing high-level insight into performance and presence over the past 30 days.  Track trends in reputation, search rankings and listing accuracy to consistently improve local SEO over time.
    `,
            templateType: "emailAlert",
            previewImg: "/images/emailAlerts/templates/images/monthly-report.jpg",
            schedule: {
              scheduleType: "Monthly",
              scheduleDay: [1],
              deliveryHour: 0,
              deliveryTimeZone: "US/Pacific"
            }, gadgets: gadgets().filter(gadget => (["listingSummary", "rankingSummary"].indexOf(gadget.type) >= 0 )),
            subject: "Your Monthly Summary"
          },
          {
            id: "CreateYourOwn",
            name: "Create-Your-Own Template",
            description: `Build your own email to custom specifications! Start by choosing the delivery schedule and recipients you desire. Next, design the email to include the content you care about by selecting from available Gadgets and filters.`,
            templateType: "emailAlert",
            previewImg: "/images/emailAlerts/templates/images/create-your-own.jpg",
            schedule: {
              scheduleType: "Monthly",
              scheduleDay: [1],
              deliveryHour: 0,
              deliveryTimeZone: "US/Pacific"
            }, gadgets: gadgets().filter(gadget => (["custom"].indexOf(gadget.type) >= 0 )),
            subject: "Your Custom Summary"
          }
        ]
      }
    }
  })

})
